const reduceItineraries = res => {
  if (!res?.length) {
    return {}
  }

  return res.reduce((obj, itinerary) => {
    return {
      ...obj,
      [itinerary.id]: {
        ...itinerary,
        startDate: itinerary?.startDate?.split('T')?.[0],
        endDate: itinerary?.endDate?.split('T')?.[0],
      },
    }
  }, {})
}

export default reduceItineraries
